// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from '@/plugins/axios'
import * as mutils from '@/plugins/mutils';
import Public_components from '@/components/index'
import '@/assets/css/main.less';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import SlideVerify from 'vue-monoplasty-slide-verify';
import 'vue-area-linkage/dist/index.css'; // v2 or higher
import VueAreaLinkage from 'vue-area-linkage';
import areaData from '@/plugins/addresslist'





Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Public_components);
Vue.use(VueAwesomeSwiper);
Vue.use(SlideVerify);
Vue.use(VueAreaLinkage)


Vue.prototype.$axios = axios;
Vue.prototype.$http = store.state.http;
Vue.prototype.$store = store;
Vue.prototype.$areaData = areaData;

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    if (localStorage.getItem('token')) {
      next();
    } else {
      next('/login');
    }
  } else {
    next();
  }
})

router.afterEach((to, from, next) => {
  document.documentElement.scrollTop = 0;

})

localStorage.getItem('token') ? axios.defaults.headers.common["Authorization"] = localStorage.getItem('token') : null;
Object.keys(mutils).forEach(key => {
  Vue.prototype["$" + key] = mutils[key];
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js